export default theme => ({
  addButton: {
    position: 'fixed',
    bottom: theme.spacing.unit * 5,
    right: theme.spacing.unit * 5
  },
  attendeeChip: { marginRight: 5, marginBottom: 5 },
  avatar: { color: '#fff', marginRight: theme.spacing.unit },
  expandSummary: { alignItems: 'center', display: 'flex', flexGrow: 1 },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary
  },
  searchInput: {
    marginBottom: theme.spacing.unit * 2,
    marginTop: theme.spacing.unit * 2,
    [theme.breakpoints.down('md')]: {
      marginLeft: theme.spacing.unit * 2,
      marginRight: theme.spacing.unit * 2
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/CourseList/Main/styles.js